const myfun = function() {};

myfun.install = (Vue, options) => {
    Vue.prototype.canDis = () => {
       return  Vue.prototype.getUser().role == 1 ? true :  Vue.prototype.in_array('/vueadmin/shop/product/dis',  Vue.prototype.getUser().role_menus);
    }
    Vue.prototype.canGroup = () => {
       return  Vue.prototype.getUser().role == 1 ? true :  Vue.prototype.in_array('/vueadmin/shop/product/group',  Vue.prototype.getUser().role_menus);
    }
    Vue.prototype.canMiaoSha = () => {
       return  Vue.prototype.getUser().role == 1 ? true :  Vue.prototype.in_array('/vueadmin/shop/product/miaosha',  Vue.prototype.getUser().role_menus);
    }
    Vue.prototype.canPoster = () => {
       return  Vue.prototype.getUser().role == 1 ? true :  Vue.prototype.in_array('/vueadmin/shop/product/poster',  Vue.prototype.getUser().role_menus);
    }
    Vue.prototype.hasPermission=(roleMenu)=>{
         return  Vue.prototype.getUser().role == 1 ? true :  Vue.prototype.in_array(roleMenu,  Vue.prototype.getUser().role_menus);
    }
}





export default myfun;



// WEBPACK FOOTER //
// ./src/public/js/myfun.js